import { useTrunkGatewayContext } from "@/react/features/support-tools/siptrunk/TrunkGatewayContext";
import lodash from "lodash";
import ValidatedInput from "@/react/features/support-tools/siptrunk/components/ValidatedInput";
import { useEffect, useState } from "react";
import schema from "./trunkGatewaySchema";
import { useFocusedField } from "@/react/features/support-tools/siptrunk/useFocusedField";

export const TrunkGatewayInputField = ({ label, path, disabled = false }) => {
  const {
    state: trunkGateway,
    updateField,
    setIsValid,
  } = useTrunkGatewayContext();
  const [error, setError] = useState("");
  const [focusedField, setFocusedField] = useState(null);

  // Trigger validations on component mount
  useEffect(() => {
    validateField(path, lodash.get(trunkGateway, path));
  }, []);

  useEffect(() => {
    setIsValid(!error);
  }, [error, setIsValid]);

  useFocusedField({ error, focusedField });

  const validateField = (name, value) => {
    try {
      const fieldData = {};
      lodash.set(fieldData, name, value);

      schema.validateSyncAt(name, fieldData);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    updateField(path, value);
    validateField(path, value);
    setFocusedField(path);
  };

  return (
    <ValidatedInput
      isDisabled={disabled}
      prompt={label}
      name={path}
      value={lodash.get(trunkGateway, path)}
      onChange={handleOnChange}
      error={error}
    />
  );
};
